export enum AbTestExperiments {
  HideBiometricsSetupLater = 'hide_biometrics_setup_later',
  ShouldEnableQuickLogin = 'should_enable_quick_login',
}

export type AbTestExperiment = AbTestExperiments;

export type AbTestExperimentEvaluatorFunction = (
  group: string
) => boolean | undefined;

export type AbTestExperimentEvaluatorMap = Record<
  AbTestExperiment,
  AbTestExperimentEvaluatorFunction
>;

export type HideBiometricsSetupLaterExperimentEvaluator = AbTestExperimentEvaluatorFunction;
export type ShouldEnableQuickLoginExperimentEvaluator = AbTestExperimentEvaluatorFunction;
